import React, { useCallback } from 'react';
import { NavLink, NavLinkProps, NavLinkRenderProps } from 'react-router-dom';
import { Icon, IconType } from '../../misc/Icon/Icon';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import {
  CardListItemSubComponentProps,
  wrapCardListItemSubComponent,
  WrappedCardListItemSubComponent
} from '../CardListItem/cardListItemSubComponent';
import styles from './CardListItemIconLink.module.css';

export type CardListItemIconLinkProps = NavLinkProps &
  CardListItemSubComponentProps<{
    iconName: string;
    iconType?: IconType;
  }>;

export const CardListItemIconLink: WrappedCardListItemSubComponent<CardListItemIconLinkProps> =
  wrapCardListItemSubComponent((props) => {
    const {
      iconName,
      iconType,
      className: classNameProp,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true,
      filter: ['cardListItemInfo']
    });

    const className = useCallback(
      (args: NavLinkRenderProps): string => {
        return classes(
          typeof classNameProp === 'function'
            ? classNameProp(args)
            : classNameProp,
          styles.link
        );
      },
      [classNameProp]
    );

    return (
      <NavLink
        {...remainingProps}
        className={className}
      >
        <Icon
          name={iconName}
          type={iconType}
        ></Icon>
      </NavLink>
    );
  });
